import { PostQuery } from 'domain/usecases';
import { RemotePostQuery } from 'data/usecases';
import { makeApiUrl } from '../../http';
import { makeAuthorizeHttpClientDecorator } from '../../decorators';

export const makeRemotePostQuery = (): PostQuery => {
  const url = `/ai/query`;

  return {
    async postQuery(body: PostQuery.Params): Promise<PostQuery.Model> {
      const remotePostQuery = new RemotePostQuery(makeApiUrl(url), makeAuthorizeHttpClientDecorator());
      return remotePostQuery.postQuery(body);
    },
  };
};
